import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=23f2b597&"
import script from "./Info.vue?vue&type=script&setup=true&lang=js&"
export * from "./Info.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports